module.exports = __webpack_public_path__ + "static/media/track_and_trace_image.f77b99ef.png";